import { render, staticRenderFns } from "./competitionWorks.vue?vue&type=template&id=a9957eb2&scoped=true&lang=html&"
import script from "./competitionWorks.vue?vue&type=script&lang=js&"
export * from "./competitionWorks.vue?vue&type=script&lang=js&"
import style0 from "./competitionWorks.vue?vue&type=style&index=0&id=a9957eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9957eb2",
  null
  
)

export default component.exports